var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiamond = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6873 2.5H5.31227L1.07227 8.15313L9.99977 18.4544L18.9273 8.15313L14.6873 2.5ZM16.8748 7.5H13.471L11.1273 3.75H14.0623L16.8748 7.5ZM6.43852 8.75L8.78477 15.1437L3.24352 8.75H6.43852ZM7.76976 8.75H12.2298L9.99914 14.8256L7.76976 8.75ZM8.00289 7.5L9.99977 4.30438L11.9973 7.5H8.00289ZM13.561 8.75H16.756L11.2141 15.1444L13.561 8.75ZM5.93727 3.75H8.87227L6.52852 7.5H3.12477L5.93727 3.75Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiamond);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/diamond.8f4ad4de1a2b6b4b56baea2b713f3b07.svg";